<div class="panel-header">
  <ng-content select="app-panel-header"></ng-content>
</div>

<div *ngIf="!isCollapsed" class="panel-content">
  <ng-content></ng-content>
</div>
